<template>
  <auth-layout ilustracao="senha" :slides="slides">
    <!-- Aberto sem ?token= (link incompleto ou digitado): avisa logo, sem mostrar o formulário -->
    <div v-if="!token" class="form">
      <h1 class="form__title">Link inválido</h1>
      <p class="form__sub">Este link de recuperação está incompleto ou já foi usado. Peça um novo para continuar.</p>
      <router-link class="btn" :to="{ name: 'recuperaracesso' }">Pedir novo link</router-link>
      <p class="foot-link">
        <router-link class="link" :to="{ name: 'login' }">Voltar para o login</router-link>
      </p>
    </div>

    <form v-else class="form" novalidate @submit.prevent="recuperarAcesso">
      <h1 class="form__title">Crie uma nova senha</h1>
      <p class="form__sub">Ela vai substituir a senha anterior da sua conta.</p>

      <div class="field">
        <label class="field__label" for="nova-email">E-mail</label>
        <input
          id="nova-email"
          :value="formCad.email"
          class="field__input"
          type="email"
          readonly
        />
      </div>

      <div class="field field--pw" :class="{ 'field--error': erros.password }">
        <label class="field__label" for="nova-senha">Nova senha</label>
        <div class="field__wrap">
          <input
            id="nova-senha"
            v-model="formCad.password"
            class="field__input"
            :type="show2 ? 'text' : 'password'"
            autocomplete="new-password"
            placeholder="Crie uma senha"
            @input="erros.password && validarCampo('password')"
          />
          <button
            type="button"
            class="field__toggle"
            :aria-label="show2 ? 'Ocultar senha' : 'Mostrar senha'"
            @click="show2 = !show2"
          >{{ show2 ? 'Ocultar' : 'Mostrar' }}</button>
        </div>
        <ul class="reqs">
          <li v-for="req in checklist" :key="req.chave" :class="{ ok: req.ok }">{{ req.texto }}</li>
        </ul>
        <div v-if="erros.password" class="field__msg">{{ erros.password }}</div>
      </div>

      <div class="field field--pw" :class="{ 'field--error': erros.confirm }">
        <label class="field__label" for="nova-confirma">Confirmar nova senha</label>
        <div class="field__wrap">
          <input
            id="nova-confirma"
            v-model="formCad.passwordConfirm"
            class="field__input"
            :type="show3 ? 'text' : 'password'"
            autocomplete="new-password"
            placeholder="Repita a senha"
            @input="erros.confirm && validarCampo('confirm')"
          />
          <button
            type="button"
            class="field__toggle"
            :aria-label="show3 ? 'Ocultar senha' : 'Mostrar senha'"
            @click="show3 = !show3"
          >{{ show3 ? 'Ocultar' : 'Mostrar' }}</button>
        </div>
        <div v-if="erros.confirm" class="field__msg">{{ erros.confirm }}</div>
      </div>

      <button class="btn" type="submit" :disabled="btnloading">
        <v-progress-circular v-if="btnloading" indeterminate size="20" width="2" color="#FFD400" />
        <span v-else>Salvar nova senha</span>
      </button>

      <p class="foot-link">
        <router-link class="link" :to="{ name: 'login' }">Voltar para o login</router-link>
      </p>
    </form>
  </auth-layout>
</template>

<script>
import AuthLayout from "@/components/auth/AuthLayout.vue";
import { checklistSenha, senhaValida } from "@/components/auth/auth.js";

export default {
  components: { AuthLayout },
  data: () => ({
    slides: [
      {
        titulo: "Senha nova, acesso seguro",
        subtitulo: "Use letras maiúsculas, minúsculas e números para proteger sua conta.",
      },
    ],
    show2: false,
    show3: false,
    token: null,
    btnloading: false,
    formCad: {
      email: null,
      password: "",
      passwordConfirm: "",
    },
    erros: {
      password: "",
      confirm: "",
    },
  }),

  computed: {
    checklist() {
      return checklistSenha(this.formCad.password);
    },
  },

  created() {
    this.token = this.$route.query.token;
    this.formCad.email = this.$route.query.email;
  },

  methods: {
    validarCampo(campo) {
      const regras = {
        password: () => senhaValida(this.formCad.password) || "A senha não atende aos requisitos.",
        confirm: () =>
          (!!this.formCad.passwordConfirm && this.formCad.passwordConfirm === this.formCad.password) ||
          "As senhas precisam ser iguais.",
      };
      const resultado = regras[campo]();
      this.erros[campo] = resultado === true ? "" : resultado;
      return resultado === true;
    },

    validar() {
      return ["password", "confirm"].map((campo) => this.validarCampo(campo)).every(Boolean);
    },

    recuperarAcesso() {
      if (this.btnloading || !this.validar()) return;

      this.btnloading = true;
      this.$http
        .post(`resetarsenha`, {
          email: this.formCad.email,
          password_confirmation: this.formCad.passwordConfirm,
          password: this.formCad.password,
          token: this.token,
        })
        .then(async () => {
          this.btnloading = false;
          await this.$swal({
            toast: false,
            icon: "success",
            title: "Senha alterada com sucesso",
            text: "Você já pode entrar com sua nova senha.",
            confirmButtonColor: "#0052A0",
            confirmButtonText: "OK",
            showConfirmButton: true,
            showCancelButton: false,
            showDenyButton: false,
          });
          this.$router.push({ name: "login" });
        })
        .catch(() => {
          this.btnloading = false;
          this.$swal({
            toast: true,
            showConfirmButton: false,
            timer: 3000,
            background: "#ff0000",
            title: '<span style="color:#FFF">Não foi possível recuperar senha</span>',
          });
        });
    },
  },
};
</script>

<style scoped src="@/components/auth/auth-form.css"></style>
